import React from "react";
import { useTable } from "react-table";
import {
  Grid,
  makeStyles,
  TextField,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  bottomBtnBlk: {
    background: "#FFFFFF",
    border: "1px solid #CCCCCC",
  },
}));

export default function ButtomBtnSection(props) {
  const { defaultValues, Controller, control, setValue, lang } =
    props;
  const classes = useStyles();

  const columns = React.useMemo(
    () => [
      {
        Header: "Button Label",
        accessor: "title",
      },
      {
        Header: "Button Link/URL",
        accessor: "url",
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: defaultValues || [],
      },
      (hook) => {
        hook.visibleColumns.push((columns) => [
          {
            id: "no",
            Header: () => <div>No</div>,
          },
          ...columns,
        ]);
      }
    );

  const handleBottomBtnLabelChange = (index, e) => {
    setValue(`social.${index}.localizations.${lang()}.title`, e.target.value);
  };

  const handleBottomBtnUrlChange = (index, e) => {
    setValue(`social.${index}.localizations.${lang()}.url`, e.target.value);
  };

  return (
    <Paper variant="outlined">
      <Table {...getTableProps()}>
        <TableHead component="div">
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) =>
                column.id === "no" ? (
                  <TableCell style={{ width: 100 }}>No</TableCell>
                ) : (
                  <TableCell {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </TableCell>
                )
              )}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <TableRow {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <TableCell {...cell.getCellProps()}>
                      {cell.column.id === "no" ? (
                        <p>{i + 1}</p>
                      ) : (
                        <>
                          <Grid
                            style={lang() === "tc" ? { display: "none" } : {}}
                          >
                            <Controller
                              name={
                                cell.column.id === "title"
                                  ? `social.${i}.localizations.en.title`
                                  : `social.${i}.localizations.en.url`
                              }
                              defaultValue={
                                cell.column.id === "title"
                                  ? defaultValues[i]
                                    ? defaultValues[i].localizations.en.title
                                    : ""
                                  : defaultValues[i]
                                  ? defaultValues[i].localizations.en.url
                                  : ""
                              }
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextField
                                  variant="outlined"
                                  margin="dense"
                                  className={classes.textInput}
                                  fullWidth
                                  {...field}
                                  onChange={
                                    cell.column.id === "title"
                                      ? (e) => handleBottomBtnLabelChange(i, e)
                                      : (e) => handleBottomBtnUrlChange(i, e)
                                  }
                                  error={!!error}
                                  helperText={error ? error.message : ""}
                                />
                              )}
                            />
                          </Grid>

                          <Grid
                            style={lang() === "en" ? { display: "none" } : {}}
                          >
                            <Controller
                              name={
                                cell.column.id === "title"
                                  ? `social.${i}.localizations.tc.title`
                                  : `social.${i}.localizations.tc.url`
                              }
                              defaultValue={
                                cell.column.id === "title"
                                  ? defaultValues[i]
                                    ? defaultValues[i].localizations.tc.title
                                    : ""
                                  : defaultValues[i]
                                  ? defaultValues[i].localizations.tc.url
                                  : ""
                              }
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextField
                                  variant="outlined"
                                  margin="dense"
                                  className={classes.textInput}
                                  fullWidth
                                  {...field}
                                  onChange={
                                    cell.column.id === "title"
                                      ? (e) => handleBottomBtnLabelChange(i, e)
                                      : (e) => handleBottomBtnUrlChange(i, e)
                                  }
                                />
                              )}
                            />
                          </Grid>
                        </>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}
